import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Tag } from 'src/app/models/tag.model';

@Component({
  selector: 'tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss']
})
export class TagComponent {
  @Input()
  tag: Tag = { name: "", _id: "", videos: [] }
}
